import getStore from "../store/store";
import type { MailboxInfo } from "owa-client-types";
import { getAccountKeyForMailboxInfo } from "owa-client-types";
import { QuickStepsLoadState } from "../store/schema/QuickStepsLoadState";

export function getQuickStepsLoadState(mailboxInfo: MailboxInfo): QuickStepsLoadState {
    const key = getAccountKeyForMailboxInfo(mailboxInfo);
    const state = getStore().loadingStatesMap.get(key);
    return state ?? QuickStepsLoadState.Uninitialized;
}
